var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",class:{
    'container--error': _vm.error,
  }},[_c('lazy-img',{staticClass:"container--image",attrs:{"alt":"Slide","src":_vm.previewUrl,"cloudflareOptions":_vm.cloudflareOptions},on:{"error":function($event){_vm.error = true}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }